import { render, staticRenderFns } from "./ModalTaulaResultatsEnquestaPlaensa.vue?vue&type=template&id=70995898&"
import script from "./ModalTaulaResultatsEnquestaPlaensa.vue?vue&type=script&lang=js&"
export * from "./ModalTaulaResultatsEnquestaPlaensa.vue?vue&type=script&lang=js&"
import style0 from "./ModalTaulaResultatsEnquestaPlaensa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports